import { Fragment } from "react";
import { Link } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import Item from "src/components/common/frame/item";
import UserInfo from "src/components/common/userInfo";
import FileSystem from "src/components/common/fileSystem1";
//--------------------------------------------------------------------------------------------
export default function Detail({
    numItemsPerColumn, 
    path1, 
    hashKeyName, 
    item, 
    setItems, 
    items, 
    dataFrame, 
    postUrl, 
    history, 
    deleteItem, 
    handleSubmit, 
    sqlTable, 
    itemLabel, 
    hashKeyLabel, 
    filesKey, 
    contacts, 
}){
    return(
    <div className = "border rounded">
        <div className = "cssSeperateWhenWide pl-3">
            <div className = {`table-responsive mr-3 ${dataFrame.find(elem => elem.position === "files")?`maxWidth-50`:`maxWidth-100`}`}>
                <table className = "table">
                    <tbody className = "noTableTopBorder">
                        {dataFrame.filter(elem => elem.position === "detail").map((elem, elemIndex) => 
                        elem.conditionalPosition && !item[elem.key]?<Fragment key = {elemIndex}></Fragment>:
                        item[elem.key]?
                        <tr key = {elemIndex}>
                            <th>{elem.title}</th>
                            <td>
                                {elem.valueType === undefined?item[elem.key]:""}
                                {["link", "internalLink", "phone", "email"].includes(elem.valueType) && item[elem.key]?
                                <>
                                    {elem.valueType === "link"?
                                        <a
                                            href = {!item[elem.key]?.startsWith("http")?"http://" + item[elem.key]:item[elem.key]}
                                            target = "_blank"
                                            rel = "noreferrer"
                                        >
                                            {item[elem.key]}
                                        </a>
                                    :<></>}
                                    {elem.valueType === "internalLink"?
                                    <Link
                                        id = {elem.preventOpenDetail?item[hashKeyName] + " " + elem.key:undefined}
                                        to = {
                                            elem.target
                                            .replace("{{value}}", item[elem.key])
                                            .replace("{{selectValue}}", item[elem.selectKey])
                                        }
                                    >
                                        {item[elem.key]}
                                    </Link>
                                    :<></>}
                                    {elem.valueType === "phone" && item[elem.key]?
                                    <a
                                        id = {elem.preventOpenDetail?item[hashKeyName] + " " + elem.key:undefined}
                                        href = {"tel:+1" + item[elem.key]}
                                        target = "_blank"
                                        rel = "noreferrer"
                                    >
                                        {item[elem.key]}
                                    </a>
                                    :<></>}
                                    {elem.valueType === "email" && item[elem.key]?
                                    <a
                                        id = {elem.preventOpenDetail?item[hashKeyName] + " " + elem.key:undefined}
                                        href = {"mailto:" + item[elem.key]}
                                        target = "_blank"
                                        rel = "noreferrer"
                                    >
                                        {item[elem.key]}
                                    </a>
                                    :<></>}
                                </>
                                :<></>}
                                {elem.valueType === "userInfo" && item[elem.userInfoEmail]?
                                <UserInfo 
                                    name = {item[elem.userInfoName]}
                                    email = {item[elem.userInfoEmail]}
                                />
                                :<></>}
                                {elem.suffix?
                                <span className = "ml-2">
                                    {item[elem.suffix]}
                                </span>
                                :<></>}
                            </td>
                        </tr>:
                        <Fragment key = {elemIndex}></Fragment>)}
                    </tbody>
                </table>
            </div>
            {dataFrame.find(elem => elem.position === "files")?
            <div className = "flex-grow-1 maxWidth-50 mr-3">
                <FileSystem
                    fileSystem = {
                        dataFrame.filter(elem => elem.position === "files").map(elem => ({
                            title: elem.title, 
                            folderIdLabel: elem.folderIdLabel, 
                            folderKey: elem.folderKey
                        }))
                    }
                    item = {item}
                    setItems = {setItems} 
                    items = {items}
                    sqlTable = {sqlTable}
                    itemLabel = {itemLabel}
                    hashKeyLabel = {hashKeyLabel}
                    filesKey = {filesKey}
                />
            </div>
            :<></>}
        </div>
        <div className = "m-3 text-right">
            <button type = "button" className = "btn btn-primary m-3" onClick = {() => history.push(`/${path1}/${item[hashKeyName]}/Edit`)}>Edit</button>
            <button type = "button" className = "btn btn-danger m-3" onClick = {deleteItem} id = {item[hashKeyName]}>Delete</button>
        </div>
        {history.location.pathname.split("/")[3] === "Edit"?
        <Item
            numItemsPerColumn = {numItemsPerColumn}
            path1 = {path1}
            postUrl = {postUrl}
            keyword = "Edit"
            closeIt = {() => history.push(`/${path1}/${item[hashKeyName]}`)}
            handleSubmit = {handleSubmit}
            item = {item}
            hashKeyName = {hashKeyName}
            dataFrame = {dataFrame}
            history = {history}

            contacts = {contacts}  
        />:<></>}
    </div>
    )
}